import { trackEvent } from 'dibs-tracking';

function trackFolderEvent(action, noteIncluded = false, itemPk = null) {
    let eventInfo = {
        label: 'search/browse',
        action,
        category: 'item favoriting',
        value: noteIncluded ? 1 : 0,
    };

    if (itemPk) {
        eventInfo = { ...eventInfo, additional: { itemPk } };
    }

    trackEvent(eventInfo);
}

export function trackFolderClick() {
    trackFolderEvent('item favoriting folder clicked');
}

export function trackItemRemoved() {
    trackFolderEvent('item removed from folder');
}

export function trackItemAdded(noteIncluded = false, itemPk = null) {
    trackFolderEvent('item added into folder', noteIncluded, itemPk);
}

export function trackFolderCreated(noteIncluded = false) {
    trackFolderEvent('item favoriting folder created', noteIncluded);
}

export default {
    trackFolderClick,
    trackItemRemoved,
    trackItemAdded,
    trackFolderCreated,
};
